<template>
  <div class="group-grid py-6 items-center text-right
              text-sm text-text-secondary font-medium">
    <AssetIcon v-if="!!currency.instrument.logo"
               :instrument="currency.instrument"
               size="big"/>
    <div v-else
         class="w-16 h-16 rounded-full bg-border
                flex items-center justify-center
                text-white"
         style="font-size: 22px">
      {{ getCodeSymbol(currency.instrument) }}
    </div>
    <div class="text-left">{{ currency.currency }}</div>
    <div>{{ +currency.share }} %</div>
    <div>{{ displayCurrencyValue(+currency.sum_base, {}, false) }}</div>
    <div>- %</div>
    <div>
      <ValueWIndicator :value="+currency.profit_absolute_day_base"
                       :percent="+currency.profit_percent_day"/>
    </div>
    <div>
      <ValueWIndicator :value="+currency.profit_absolute_month_base"
                       :percent="+currency.profit_percent_month"/>
    </div>
    <div>
      <ValueWIndicator :value="+currency.profit_absolute_base"
                       :percent="+currency.profit_percent"/>
    </div>
  </div>
</template>


<script>
import ValueWIndicator
  from "@/components/common/Investments/ValueWIndicator";
import {mapGetters, mapState} from "vuex";
import AssetIcon from "@/components/cabinet/Investments/InvestmentAssets/InvestmentAssetItem/AssetIcon";

export default {
  name: "PortfolioCurrencyItem",
  components: {AssetIcon, ValueWIndicator},
  props: {
    currency: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters('cabinet/currencies', ['getCurrencyByCode', 'displayCurrencyValue'])
  },
  methods: {
    getCodeSymbol(code) {
      let currencyCode = code.length === 3 ? code : code.substring(0, 3)
      return this.getCurrencyByCode(currencyCode).symbol;
    }
  }
}
</script>